<template>
  <section class="about__area pt-90 pb-150">
    <div class="container">
      <div class="row">
        <div class="col-12 mb-50 text-center">
          <h2 class="section__title" style="font-size: 30px; text-transform: uppercase">price Raqamlashtirish: jamiyat, tashkilot va xodimlar uchun yangi bosqich</h2>
        </div>
      </div>
      <div class="row mb-50">
        <div class="col-lg-8 col-12">
          <div class="about__content pl-10 pr-10 pt-25">
            <div class="about__list mb-35">
              <p style="list-style-type: disc; font-size: 16px; font-weight: 500; color: #0e1133;">
                "Raqamli transformatsiya va autsorsing markazi" davlat muassasasidada biz raqamlashtirishni — ya’ni ish jarayonlarini axborot tizimlari yordamida avtomatlashtirish,
                xizmatlarni onlayn shaklga o‘tkazish, ma’lumot oqimlarini tez va xavfsiz tashkil etishni — asosiy yo‘nalishlardan biri deb bilamiz.
                Bugungi kunda raqamli texnologiyalar – faqat «yoqsa bo‘ladi» degan qo‘shimcha emas, balki har bir tashkilotning muntazam yuritiladigan ishiga aylanmoqda.
                Tashkilot ichidagi jarayonlardan tortib, fuqarolarga ko‘rsatiladigan xizmatlargacha – barcha bosqichlarda “qog‘ozdan axborot tizimiga” degan tamoyil asosida ish olib borilmoqda.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12">
          <div class="about__thumb-wrapper">
            <div class="about__thumb">
              <img src="../../assets/img/raqam6.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-12">
          <div class="about__thumb-wrapper">
            <div class="about__thumb pt-50">
              <img src="../../assets/img/raqam5.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-12">
          <div class="about__content pl-10 pr-10 pt-10">
            <div class="section__title-wrapper mb-25">
              <h2 class="section__title" style="font-size: 26px">Asosiy yo‘nalishlar</h2>
            </div>
            <div class="about__list mb-35">
              <h4>Ichki jarayonlarni raqamlashtirish:</h4>
              <ul>
                <li><i class="icon_check"></i>Boshqaruv, arxiv, ma’lumot almashish tizimlari IT-platformaga o‘tilmoqda;</li>
                <li><i class="icon_check"></i>Huquqiy hujjatlar, ichki hisobotlar, ma’lumot bazalari — onlayn shaklda yuritilishi;</li>
              </ul>
              <h4>Xizmatlarning onlayn shaklga o‘tishi:</h4>
              <ul>
                <li><i class="icon_check"></i>Fuqarolar va tashkilotlar bilan muloqot, murojaatlar, arizalar — elektron formatga ko‘chirilmoqda;</li>
                <li><i class="icon_check"></i>“Bir oynada” xizmat ko‘rsatish, mobil ilovalar, web-portallar orqali xizmat olish imkoniyati yaratilmoqda;</li>
              </ul>
              <h4>Ma’lumot xavfsizligi va kibergarcha tayyorgarlik:</h4>
              <ul>
                <li><i class="icon_check"></i>Raqamlashtirish bilan birga — ma’lumotlarni himoya qilish, zaxiralash, shifrlash tizimlari joriy qilinmoqda;</li>
                <li><i class="icon_check"></i>Tashkilot xodimlari uchun kiberxavfsizlik bo‘yicha mashg‘ulotlar, treninglar taqdim etilmoqda;</li>
              </ul>
              <h4>Hamkorlik va tarmoqlararo integratsiya:</h4>
              <ul>
                <li><i class="icon_check"></i>Turli davlat organlari, IT-kompaniyalar, tadbirkorlik sub’yektlari bilan hamkorlikda raqamli yechimlar ishlab chiqilmoqda;</li>
                <li><i class="icon_check"></i>Tarmoq ichida ma’lumot va xizmat integratsiyasi orqali “ko‘p bosqichli jarayonlar → bir bosqichga” tamoyili amalda;</li>
              </ul>
              <h4>Natijalar va kelajak istiqbollari:</h4>
              <ul>
                <li><i class="icon_check"></i>Raqamlashtirish orqali operatsion xarajatlar kamayadi, xizmat ko‘rsatuvchanlik oshadi, javob berish tezligi yaxshilanadi;</li>
                <li><i class="icon_check"></i>Kelajakda “aqlli xizmatlar”, AI bilan qo‘llaniladigan jarayonlar, kengaytirilgan tahlillar kutilyapti;</li>
              </ul>

            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name:'RaqamArea'
};
</script>
